module.exports = __webpack_public_path__ + "static/img/iconfont.b869ec8e.svg";